import React from 'react';
import { useSelector } from 'react-redux';
import { ButtonType } from '../../../../../ui/buttonTypes';
import SchoolInfo from '../../shared/SchoolInfo/SchoolInfo';
import BtnComponent from '../../../../ui/buttons/BtnComponent';
import classes from './registeredTeacherContestStage.module.css';

const RegisteredTeacherContestStage = () => {

    const { texts } = useSelector((state) => state.translate);

    return (
        <div className={classes.registeredTeacherContestStage}>
            <div className={classes.rightAndMiddleWrapper}>
                <SchoolInfo />
            </div>
            <div className={classes.btnWrapper}>
                <BtnComponent type={ButtonType.PLAY} text={texts.btnPlay} />
            </div>
        </div>
    );
};

export default RegisteredTeacherContestStage;

